inputs-select
  div(class="form-group row { error: opts.errors }")
    label.col-md-4.col-form-label
      | {opts.label}
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      select.form-control(name="{ opts.name }")
        option(each="{ item, index in opts.items }" selected="{ selected: item.value === parent.opts.value }" value="{ item.value }") { item.text }
      div.help-block(if="{ opts.errors }")
        ul(role="alert")
          li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.select');
